import { useEffect } from "react";
import { useContent } from "../../context/ContentContext";

// Applies the admin-configured global text scale to the festival routes only.
// (Restores the previous root size when leaving the Festival universe.)
export const FestivalTypography = () => {
  const { content } = useContent();
  const scale = content?.festivalArchive?.theme?.fonts?.scale || 1;
  useEffect(() => {
    const el = document.documentElement;
    const prev = el.style.fontSize;
    el.style.fontSize = `${Math.round((scale || 1) * 100)}%`;
    return () => { el.style.fontSize = prev; };
  }, [scale]);
  return null;
};
